module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-400.7812f173.woff2";